/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import {
    bottomButtonsGridItem,
    buttonsGridItem,
    cancelButton,
    removeIcon,
    titleGridItems,
} from "@monsma/App/WidgetExtensions/Budget/BudgetExtension";

import { costCodesStyles } from "@monsma/Overrides/Widgets/Budget/CostCodes";
import { screen } from "@monsma/XDL/Helpers";
import { css } from "styled-components";

costCodesStyles.titleGridItems = titleGridItems;

costCodesStyles.buttonsGridItem = buttonsGridItem;

costCodesStyles.cancelButton = cancelButton;

costCodesStyles.addCostCodeButtonGridItems = {
    width: 12,
    css: css`
        padding-bottom: 15px;
    `,
};

costCodesStyles.removeIcon = removeIcon;

costCodesStyles.addCostCodeButton = {
    css: css`
        display: block;

        ${TypographyStyle} {
            height: 100%;
            align-items: center;
            display: flex;
            justify-content: center;
        }

        &&& {
            ${screen("lte", "sm")} {
                width: 100%;
            }
        }
    `,
    variant: "secondary",
};

costCodesStyles.xCostCodesStyles = {
    bottomButtonsGridItem: { ...bottomButtonsGridItem },
};
